import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SearchNotificationService } from "../search-notification.service";

@Component({
  selector: "app-driver-load-search-list",
  templateUrl: "./driver-load-search-list.component.html",
  styleUrls: ["./driver-load-search-list.component.sass"],
})
export class DriverLoadSearchListComponent implements OnInit {
  searchHistory: any[] = [];

  loading = false;

  page = 1;
  limit = 10;
  total = 0;
  totalPages = 0;

  constructor(
    private searchHistoryService: SearchNotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getSearchHistory();
  }

  getSearchHistory(): void {
    this.loading = true;

    const data = {
      page: this.page,
      limit: this.limit,
    };

    this.searchHistoryService.getDriverSearchHistory(data).subscribe(
      (res: any) => {
        this.loading = false;

        if (res && res.success) {
          this.searchHistory = res.data || [];

          if (res.pagination) {
            this.page = res.pagination.page;
            this.limit = res.pagination.limit;
            this.total = res.pagination.total;
            this.totalPages = res.pagination.totalPages;
          }
        } else {
          this.searchHistory = [];
          this.total = 0;
          this.totalPages = 0;
        }
      },
      (error) => {
        this.loading = false;
        this.searchHistory = [];

        this.total = 0;
        this.totalPages = 0;

        console.error("Error fetching driver search history:", error);
      },
    );
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.page) {
      return;
    }

    this.page = page;
    this.getSearchHistory();
  }

  nextPage(): void {
    if (this.page < this.totalPages) {
      this.page++;
      this.getSearchHistory();
    }
  }

  previousPage(): void {
    if (this.page > 1) {
      this.page--;
      this.getSearchHistory();
    }
  }

  viewDetails(id: any): void {
    if (!id) {
      return;
    }

    this.router.navigate(["/dashboard/driver-view-load-search"], {
      queryParams: {
        id: id,
      },
    });
  }

  trackById(index: number, item: any): any {
    return item._id;
  }
}
